import { Grid, Typography } from "@mui/material";

function importAll(r) {
  return r.keys().map((key) => ({
    name: key.replace("./", "").replace(".jsx", ""),
    IconComponent: r(key).default,
  }));
}

const icons = importAll(require.context("../assets/SVG", false, /\.jsx$/));

function Icons() {
  return (
    <Grid container spacing={2}>
      {icons.map(({ name, IconComponent }) => (
        <Grid
          item
          key={name}
          display="flex"
          flexDirection="column"
          alignItems="center"
        >
          {IconComponent && <IconComponent color="black" />}

          <Typography variant="caption">{name}</Typography>
        </Grid>
      ))}
    </Grid>
  );
}

export default Icons;
